import React from 'react'
import {ButtonBase} from '@mui/material'
import {alpha} from '@mui/material/styles'
import CheckIcon from '@mui/icons-material/Check'
import {NEUTRAL_SCALE} from 'src/theme-new/tokens'

// A selectable pill for picking one value out of a short list of shortcuts — lighter than a row of
// full Buttons, and the selected one reads as "chosen" (brand tint + check) rather than as a
// primary call to action.

interface ChoiceChipProps {
  label: string
  selected?: boolean
  disabled?: boolean
  onClick: () => void
}

export default function ChoiceChip({label, selected, disabled, onClick}: ChoiceChipProps): JSX.Element {
  return (
    <ButtonBase
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
      sx={theme => ({
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        height: 36,
        px: 2,
        borderRadius: 9999,
        border: '1px solid',
        fontSize: 14,
        fontWeight: selected ? 600 : 500,
        transition: theme.transitions.create(['background-color', 'border-color', 'color'], {duration: 150}),
        ...(selected
          ? {
            borderColor: theme.palette.primary.main,
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
            color: theme.palette.primary.main
          }
          : {
            borderColor: NEUTRAL_SCALE[300],
            backgroundColor: theme.palette.background.paper,
            color: NEUTRAL_SCALE[700],
            '&:hover': {borderColor: NEUTRAL_SCALE[500], backgroundColor: NEUTRAL_SCALE[50]}
          }),
        '&.Mui-disabled': {opacity: 0.5},
        '&.Mui-focusVisible': {outline: `2px solid ${alpha(theme.palette.primary.main, 0.4)}`, outlineOffset: 2}
      })}
    >
      {selected && <CheckIcon sx={{fontSize: 16, ml: -0.5}} />}
      {label}
    </ButtonBase>
  )
}
